@if (!(loading | async)) {
  <div class="report-claim">
    <div class="row">
      <div class="column twelve">
        <h4 class="pad-bottom-20">
          <span dsContent [contentPath]="'claims.fnol.giveUsACall'"></span>
          <a
            (click)="callUs()"
            dsContent
            dsPartnerContent
            [brandContent]="'selectPrettyClaimPhoneNum'"
            [brandHref]="'selectClaimPhoneNumFullHref'"
          >
          </a>
        </h4>
        @if (!!hasInjury) {
          <p class="pad-bottom-20" dsContent [contentPath]="'claims.fnol.injuryContactText'"></p>
        }
        <p class="pad-bottom-20">
          <span dsContent [contentPath]="'claims.fnol.contactText1'"></span>
          <a
            (click)="callUs()"
            dsContent
            dsPartnerContent
            [brandContent]="'selectPrettyClaimPhoneNum'"
            [brandHref]="'selectClaimPhoneNumFullHref'"
          ></a>
          <span dsContent [contentPath]="'claims.fnol.contactText2'"></span>
        </p>
      </div>
    </div>
    <div class="row callToAction">
      <span class="column twelve md-text-right">
        <button
          ds-button
          type="button"
          (click)="callUs()"
          dsContent
          [contentPath]="'shared.callUs'"
        ></button>
      </span>
    </div>
  </div>
}
